import PageTitle from './PageTitle';
import UserProfile from './UserProfile';

const ProfileSettings = () => {
  return (
    <section className="content-width ps-3 pe-3">
      <PageTitle className="mb-4">Moji podaci i podešavanja</PageTitle>

      <UserProfile />
    </section>
  );
};

export default ProfileSettings;
